import { IApplication } from '../types';

const normalize = (value: string) =>
  value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Filtro client-side da tabela de candidatos: por nome (civil ou social,
// ignorando acentos) ou por CPF (com ou sem máscara).
export const filterApplications = (applications: IApplication[], query: string): IApplication[] => {
  const text = normalize(query.trim());

  if (!text) return applications;

  const digits = text.replace(/\D/g, '');

  return applications.filter(application => {
    const names = [application.real_name, application.assumed_name || ''];

    return (
      names.some(name => normalize(name).includes(text)) ||
      (digits.length > 0 && application.cpf.includes(digits))
    );
  });
};
